import { createI18n } from 'vue-i18n'
import pluralizationRules from './plural.js'
import { useStatusStore } from '@/store/status'

export const i18n = createI18n({
	legacy: true,
	locale: 'en',
	fallbackLocale: 'en',
	messages: {
		en: {
			common: {
				currencies_short: {
					aed: 'AED',
					ars: '$Ar',
					aud: 'A$',
					brl: 'R$',
					cad: 'C$',
					chf: 'CHF',
					clp: 'CLP$',
					cop: 'Col$',
					dkk: 'kr.',
					eur: '€',
					gbp: '£',
					jpy: '¥',
					mxn: 'M$',
					nok: 'kr',
					nzd: 'NZ$',
					sek: 'kr',
					try: '₺',
					usd: '$',
				},
				duration: {
					days: {
						base: 'day | {n} days',
						dashed: {
							capitalized: '{n}-Day | {n}-Day',
							lowercase: '{n}-day | {n}-day',
							uppercase: '{n}-DAY | {n}-DAY',
						},
						first: 'first day | first {n} days',
						interval: 'daily',
						short: '{n}d | {n}days',
					},
					month: {
						base: 'month | {n} months',
						dashed: {
							capitalized: '{n}-Month | {n}-Month',
							lowercase: '{n}-month | {n}-month',
							uppercase: '{n}-MONTH | {n}-MONTH',
						},
						first: 'first month | first {n} months',
						interval: 'monthly',
						short: 'mo | {n}mo',
					},
					week: {
						base: 'week | {n} weeks',
						dashed: {
							capitalized: '{n}-Week | {n}-Week',
							lowercase: '{n}-week | {n}-week',
							uppercase: '{n}-WEEK | {n}-WEEK',
						},
						first: 'first week | first {n} weeks',
						interval: 'weekly',
						short: '{n}w | {n}wks',
					},
				},
				kg_plural: '{n} kg | {n} kg',
				lbs_plural: '{n} lbs | {n} lbs',
				month_dashed: '{n}-month | {n}-month',
				month_plural: '{n} month | {n} months',
				st_plural: '{n} st | {n} st',
				week_dashed: '{n}-week | {n}-week',
				week_plural: '{n} week | {n} weeks',
			},
		},
	},
	pluralizationRules,
	warnHtmlInMessage: 'off',
	fallbackWarn: false,
	missingWarn: false,
})

export function loadLanguageAsync() {
	document.documentElement.setAttribute('lang', 'en')
	useStatusStore().setResourceReadiness('i18n')
}
